
/**
 * Convert H2 tags to collapsable headers
 */
(function ()
{
    const addClass = (elementOrElementArray, className) =>
    {
        const elementSet = (Array.isArray(elementOrElementArray) ? elementOrElementArray : [elementOrElementArray]);
        for (let elmnt of elementSet)
        {
            elmnt.className = elmnt.className.indexOf(' ' + className) < 0 ? elmnt.className += ' ' + className : elmnt.className;
        }
    };
    const removeClass = (elementOrElementArray, className) =>
    {
        const elementSet = (Array.isArray(elementOrElementArray) ? elementOrElementArray : [elementOrElementArray]),
            classRipper = new RegExp('(?:^|\\s)' + className + '(?:\\s|$)', 'g');
        for (let elmnt of elementSet)
        {
            elmnt.className = elmnt.className.replace(classRipper, ' ').trim();
        }
    };
    const hasClass = (elt, className) => 
    {
        return (elt !== undefined) && (elt !== null) && ((' ' + elt.className + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + className + ' ') > -1);
    };
    const isToggleEnabled = (h) =>
    {
        return !hasClass(h, 'ia-no-toggle') && 
                !hasClass(h, 'no-toggle') && 
                !hasClass(h, 'ia-expandable') && 
                !hasClass(h, 'ia-report-section-title') && // special invisible but for screen-readers
                (h.innerHTML !== '') && // don't collapse :empty headers, because nothing to click
                (h.closest('ia-expandable-disabled') === null);
    };
    const collapseId = (new Date()).getTime().toFixed(0) + (Math.random() * 100.0).toFixed(0)
        forceCollapseSelector = 'ia-collapse-' + collapseId;
    const togglerEventHandler = (e) =>
    {
        const btn = e.currentTarget,
            hdg = btn.closest('h2'),
            idsList = btn.getAttribute('aria-controls'),
            ids = (idsList !== undefined && idsList !== null ? idsList.split(' ') : []),
            elements = ids.map(id => document.querySelector('[data-ia-control-id="' + id + '"]')).filter(elm => elm !== undefined && elm !== null);
        if (hasClass(hdg, 'ia-open'))
        {
            addClass(elements, forceCollapseSelector);
            removeClass(hdg, 'ia-open');
            removeClass(hdg, 'expanded');
            addClass(hdg, 'ia-closed');
            btn.setAttribute('aria-expanded', 'false');
            for (let s of elements)
            {
                const links = s.querySelectorAll('a');
                links.forEach(a => {
                    a.setAttribute('tabindex', '-1');
                });
            }
        }
        else
        {
            removeClass(elements, forceCollapseSelector);
            removeClass(hdg, 'ia-closed');
            addClass(hdg, 'ia-open');
            addClass(hdg, 'expanded');
            btn.setAttribute('aria-expanded', 'true');
            for (let s of elements)
            {
                const links = s.querySelectorAll('a');
                links.forEach(a => {
                    a.removeAttribute('tabindex');
                });
            }
        }
    };
    window.iaBuildToggles = () =>
    {
        const toggleSelector = '.entry-content h2',
            h2s = Array.from(document.querySelectorAll(toggleSelector)).filter(h => isToggleEnabled(h)),
            styleTag = document.createElement('style'),
            forceCollapseCss = 
                '.' + forceCollapseSelector + ',' + // standard
                '.ia-report-viewer .ia-report-widget.ia-text-box-widget.ia-widget-container.' + forceCollapseSelector + ',' + // reports, migrated
                '.ia-report-viewer .ia-report-widget .ia-widget-container.' + forceCollapseSelector + // reports, migrated
                '{ height: 0px !important; margin-top: 0px !important; margin-bottom: 0px !important; }';
        if (h2s.length > 0)
        {
            const exs = document.getElementById('iaStyleCollapse' + collapseId);
            if (exs !== undefined && exs !== null) exs.remove();
            styleTag.setAttribute('id', 'iaStyleCollapse' + collapseId);
            styleTag.appendChild(document.createTextNode(forceCollapseCss));
            document.head.appendChild(styleTag);
            addClass(h2s, 'expandable');
            addClass(h2s, 'ia-expandable');
            let inReport = false;
            h2s.forEach((h, i) =>
            {
                const html = h.innerHTML, 
                    b = document.createElement('button'), 
                    ids = [],
                    w = h.closest('.ia-report-widget');
                let siblings = [];
                while (h.firstChild !== undefined && h.firstChild !== null) h.firstChild.remove();
                b.innerHTML = html;
                h.appendChild(b);
                // Where is this? Is it part of a report
                if (w !== undefined && w !== null)
                {
                    siblings = Array.from(w.parentElement.querySelectorAll('.ia-report-widget'));
                    const wid = w.getAttribute('data-uuid'),
                        start = siblings.findIndex(ww => ww.getAttribute('data-uuid') === wid) + 1,
                        cut = siblings.findIndex((ww, i) => (i > start) && (ww.querySelector('h2') !== undefined && ww.querySelector('h2') !== null));
                    siblings = siblings.slice(start);
                    if (cut > 0) siblings = siblings.slice(0, cut - start);
                    inReport = true;
                }
                else 
                {
                    let n = h.nextElementSibling;
                    while (n !== undefined && n !== null && n.tagName !== 'H2')
                    {
                        siblings.push(n);
                        n = n.nextElementSibling;
                    }
                }
                siblings.forEach((e, j) =>
                {
                    let id = e.getAttribute('id');
                    if ((id === undefined) || (id === null))
                    {
                        id = 'iacontrolled_' + i + '_' + j;
                    }
                    e.setAttribute('data-ia-control-id', id);
                    ids.push(id);
                    e.style.transition = 'height .25s, margin-top .25s, margin-bottom .25s';
                    e.style.overflow = 'hidden';
                    e.style.boxSizing = 'border-box'; // explicit with overflow
                });
                b.setAttribute('class', 'ia-undecorated ia-internal');
                b.setAttribute('aria-controls', ids.join(' '));
                b.setAttribute('aria-expanded', 'true');
                b.addEventListener('click', togglerEventHandler);
                b.addEventListener('mouseup', (e) =>
                {
                    const eb = e.currentTarget;
                    setTimeout(() => {
                        eb.blur();
                    }, 50); // Remove focus on mouseup to clear visual state
                });
                addClass(h, 'ia-open');
                b.click();
            });
            if (!inReport && h2s.length > 0)
            {
                const bex = document.createElement('button'),
                    bco = document.createElement('button'),
                    controls = document.createElement('div');
                controls.setAttribute('class', 'ia-controls ia-controls-expand-collapse-all'); //" style="text-align: right;">').append(expand).append().append(collapse);
                bex.setAttribute('class', 'ia-undecorated');
                bex.appendChild(document.createTextNode('Expand all'));
                bco.setAttribute('class', 'ia-undecorated');
                bco.appendChild(document.createTextNode('Collapse all'));
                controls.appendChild(bex);
                controls.appendChild(document.createTextNode(' / '));
                controls.appendChild(bco);
                h2s[0].parentElement.insertBefore(controls, h2s[0]);
                bco.addEventListener('click', (e) =>
                {
                    const exp = document.querySelectorAll('h2.ia-expandable.ia-open > button.ia-internal');
                    exp.forEach(b => 
                    {
                        b.click();
                    });
                    e.preventDefault();
                });
                bex.addEventListener('click', (e) =>
                {
                    const col = document.querySelectorAll('h2.ia-expandable.ia-closed > button.ia-internal');
                    col.forEach(b => 
                    {
                        b.click();
                    });
                    e.preventDefault();
                });
            }
        }
    };
})();
